
export class UiErrorMessage extends Error {
  constructor(public uiMessage: string) {
    super(uiMessage);
  }
}
